module.exports = __webpack_public_path__ + "static/media/01.cb03222d.png";